/*
|--------------------------------------------------------------------------
| Views: Article Story Stack
|--------------------------------------------------------------------------
*/


/**
 * Article Story Stack Widget View
 * @namespace
 */

// __gh__webApp.views.mostPopularWidget = {
__gh__webApp.views.articleStoryStack = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},
	
	"getSubView": function(bucket){		
		
		//Update bucket
		bucket.view.name = "buckets/articleStoryStack/default";
		bucket.view.staticName = "articleStoryStack";
		
		bucket.view.sliderSettings 			= this.getSliderSettings(bucket.id);

		return bucket;
	},


	"getSliderSettings":function(){
		var sliderSettings = {
			"rows":4,
			"slidesPerRow":1,
			"adaptiveHeight":true,
			"dots":true,
			"arrows":false
		};
		
		return sliderSettings;
	}

};
